export default "__VITE_ASSET__$r4lu0PS__"